'use client';

import { useState } from 'react';
import { useParams } from 'next/navigation';
import { useQuery } from '@apollo/client/react';
import Loading from '@/components/loading';
import ErrorMessage from '@/components/error-message';
import NotFound from '@/components/not-found';
import LoginRequired from '@/components/login-required';
import { groupMembersQuery } from '@/apollo/groups';
import VerticalTabs from '@/components/vertical-tabs';
import MembersTab from '@/components/groups/members-tab';
import InvitesTab from '@/components/groups/invites-tab';

const GroupMembersPageClient = () => {
  const { slug } = useParams();
  const [currentTab, setCurrentTab] = useState('members');

  const { data, loading, error } = useQuery(groupMembersQuery, {
    variables: { slug },
    ssr: false,
  });
  const group = data?.group;

  if (error) {
    return <ErrorMessage message='An error occurred while loading group.' error={error} />;
  }
  if (loading) { return <Loading />; }
  if (!group || group.found) { return <NotFound />; }
  if (!group.permissions.accessible) {
    return <LoginRequired />;
  }

  return (
    <>
      {group.permissions.editable ? (
        <VerticalTabs
          tabs={[
            { label: 'Members', tab: 'members' },
            { label: 'Invites', tab: 'invites' }
          ]}
          currentTab={currentTab}
          onChange={(e, newTab) => setCurrentTab(newTab)}
        >
          <VerticalTabs.TabPanel tab="members" currentTab={currentTab}>
            <MembersTab group={group} />
          </VerticalTabs.TabPanel>

          <VerticalTabs.TabPanel tab="invites" currentTab={currentTab}>
            <InvitesTab group={group} />
          </VerticalTabs.TabPanel>
        </VerticalTabs>
      ) : (
        <MembersTab group={group} />
      )}
    </>
  );
};

export default GroupMembersPageClient;
